import { useContext } from 'react';

import { globalTourSteps } from 'constants/tour';

import { ProvisionEdgeNodeButton } from './_components/ProvisionEdgeNodeButton';

import { NodeList } from './NodeList';
import { NodesContext } from './NodesProvider';
import { nodeListTourId, nodeListTourStepsOrder } from './tourSteps';
import { FailedToDrainNodesAlert } from '../_components/FailedToDrainNodesAlert';
import { PageHeaderWithClusterWarnings } from '../_components/PageHeaderWithClusterWarnings';
import { useHasFailedToDrainNodes } from '../_hooks/useHasFailedToDrainNodes';
import { Box, Stack } from '@cast/design-system';

export const Nodes = () => {
  const { isLoading, nodes, error, refetch, workloads } =
    useContext(NodesContext);
  const hasFailedToDrainNodes = useHasFailedToDrainNodes();

  return (
    <Stack height="100%">
      <PageHeaderWithClusterWarnings
        heading="Node list"
        initiateTour={{
          steps: nodeListTourStepsOrder,
          type: nodeListTourId,
          message:
            'Node list allows you to quickly find a specific node, or sort and filter the list based on criteria.',
          globalTourStepProps: {
            [globalTourSteps.connectMyCluster]: {
              text: "Connect your cluster and see every node that's running within it.",
            },
          },
        }}
      >
        <ProvisionEdgeNodeButton />
      </PageHeaderWithClusterWarnings>
      {hasFailedToDrainNodes && (
        <Box mb={24}>
          <FailedToDrainNodesAlert />
        </Box>
      )}

      <NodeList
        workloads={workloads}
        isLoading={isLoading}
        nodes={nodes}
        error={error}
        refetch={refetch}
      />
    </Stack>
  );
};
